import { useState, useEffect } from 'react';
import { IBudgetProposals, IProposal } from '@opengov/stories-shared/types';
import { transport } from '@opengov/app-core/transport';

export function useGetProposalsInBudget(budgetId: number, selectedProposals: IBudgetProposals[] | null) {
  const [isLoadingProposals, setIsLoadingProposals] = useState<boolean>(false);
  const [proposalsList, setProposalsList] = useState<IProposal[]>([]);

  useEffect(() => {
    if (!budgetId) return;
    setIsLoadingProposals(true);
    void transport
      .url(`/api/v3/proposals?limit=1000&offset=0&budget_id=${budgetId}`)
      .get()
      .json<{ proposals: IProposal[] }>()
      .then((response) => {
        const proposals = response?.proposals || [];
        const selectedProposalIds = selectedProposals?.map((p) => p.proposalId) ?? [];
        setProposalsList(
          proposals.map((proposal) => ({
            ...proposal,
            disabled: selectedProposalIds.includes(proposal.id)
          }))
        );
      })
      .finally(() => setIsLoadingProposals(false));
  }, [budgetId]);

  return { isLoadingProposals, proposalsList };
}
